import { defineMessages } from 'react-intl';

export const actionCardMessages = defineMessages({
  actionPriceDescription: {
    id: 'pd.action.price.description',
    defaultMessage: 'Akční cena platí po omezenou dobu',
  },
});
